<div class="box" id="playercontainer">
    <video>
        <!-- <source src="http://video.webmfiles.org/big-buck-bunny_trailer.webm" type="video/webm"/> -->
  
        <source src="{{url}}" type="video/webm"/>
        <source src="{{url}}" type="video/mp4"/>
    </video>
</div>